<template>
	<div>
		<apexchart type="bar" height="350" :options="chartOptions" :series="chartSeries"></apexchart>
	</div>
</template>
<script>
import { mapGetters, mapActions } from "vuex"
export default {
	name: "schools-chart",
	data() {
		return {
			schools: [],

			searchable: false,
			filter: {
				from_month: undefined,
				to_year: undefined,
				to_month: undefined,
				to_year: undefined
			},

			chartOptions: {
				chart: {
					height: 350,
					type: "bar"
				},
				plotOptions: {
					bar: {
						borderRadius: 10,
						dataLabels: {
							position: "top" // top, center, bottom
						}
					}
				},
				dataLabels: {
					enabled: true,
					formatter: function (val) {
						return val + "%"
					},
					offsetY: -20,
					style: {
						fontSize: "12px",
						colors: ["#304758"]
					}
				},

				xaxis: {
					categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
					position: "top",
					axisBorder: {
						show: false
					},
					axisTicks: {
						show: false
					},
					crosshairs: {
						fill: {
							type: "gradient",
							gradient: {
								colorFrom: "#D8E3F0",
								colorTo: "#BED1E6",
								stops: [0, 100],
								opacityFrom: 0.4,
								opacityTo: 0.5
							}
						}
					},
					tooltip: {
						enabled: true
					}
				},
				yaxis: {
					axisBorder: {
						show: false
					},
					axisTicks: {
						show: false
					},
					labels: {
						show: false,
						formatter: function (val) {
							return val + "%"
						}
					}
				},
				title: {
					text: "Monthly Inflation in Argentina, 2002",
					floating: true,
					offsetY: 330,
					align: "center",
					style: {
						color: "#444"
					}
				}
			},
			chartSeries: [
				{
					data: [2.3, 3.1, 4.0, 10.1, 4.0, 3.6, 3.2, 2.3, 1.4, 0.8, 0.5, 0.2]
				}
			]
		}
	},
	computed: {
		...mapGetters({
			MONTHS: "dashboard/months",
			YEARS: "dashboard/years"
		})
	},
	created() {
		this.filter = {
			from_year: new Date().getFullYear(),
			to_year: new Date().getFullYear(),
			from_month: this.MONTHS[new Date().getMonth() - 1],
			to_month: this.MONTHS[new Date().getMonth()]
		}
		this.handleSearch()
	},
	methods: {
		...mapActions({
			doSchools: "dashboard/doSchoolsRange"
		}),
		handleSearch: function () {
			this.searchable = false
			this.search()
		},
		async search() {
			var result = await this.doSchools({
				to_year: this.filter.to_year + "",
				from_year: this.filter.from_year + "",
				from_month: this.MONTHS.indexOf(this.filter.from_month),
				to_month: this.MONTHS.indexOf(this.filter.to_month)
			})
		}
	}
}
</script>
